// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qj_a bhi_su bhi_kv bhi_kw","PostDetailRight__brandDaysPosts":"qj_b bhi_su bhi_kv bhi_kw"};